export default Object.freeze({
  All: 1,
  ProcessInstance: 2,
  List: 3,
  Entity: 4,
  Chat: 5,
  BulkRequest: 6,
});
